var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9973 11.9987C23.9973 18.6254 18.6254 23.9973 11.9987 23.9973C5.37196 23.9973 0 18.6254 0 11.9987C0 5.37196 5.37196 0 11.9987 0C18.6254 0 23.9973 5.37196 23.9973 11.9987ZM10.6108 18.3519L19.513 9.44962C19.8153 9.14733 19.8153 8.65718 19.513 8.35489L18.4183 7.26016C18.116 6.95782 17.6258 6.95782 17.3235 7.26016L10.0634 14.5202L6.67382 11.1306C6.37153 10.8284 5.88138 10.8284 5.57904 11.1306L4.48431 12.2254C4.18202 12.5277 4.18202 13.0178 4.48431 13.3201L9.516 18.3518C9.81834 18.6541 10.3084 18.6541 10.6108 18.3519Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletionIcon);
export default __webpack_public_path__ + "static/media/completion-icon.f318eb1cd7780ab2c603ddbccdb1e89d.svg";
export { ForwardRef as ReactComponent };